// reducers/sitesReducer.js
import {
  LOAD_SITE_LIST_REQUEST,
  LOAD_SITE_LIST_SUCCESS,
  LOAD_SITE_LIST_FAILURE,
} from '../../config/actions';

const initialState = {
  siteList: {
    data: [],
    pagination: {
      limit: 20,
      hasNextPage: false,
      nextCursor: null,
    },
    loading: false,
    error: null,
  },
};

export const sitesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SITE_LIST_REQUEST:
      return {
        ...state,
        siteList: {
          ...state.siteList,
          loading: true,
          error: null,
        },
      };

    case LOAD_SITE_LIST_SUCCESS:
      const newState = {
        ...state,
        siteList: {
          data: action.payload.append
            ? [...state.siteList.data, ...action.payload.data] // <-- append mode
            : action.payload.data,                             // <-- reset mode
          pagination: action.payload.pagination,
          loading: false,
          error: null,
        },
      };
      
      return newState;

    case LOAD_SITE_LIST_FAILURE:
      return {
        ...state,
        siteList: {
          ...state.siteList,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default sitesReducer;